let bannerTitle = $('#discountBannerTitle'),
    bannerTitleContent = $(bannerTitle).attr('data-content'),
    bannerTitleMorningContent = $(bannerTitle).attr('data-morningsale-content');

/**
 * Set title if Morning Sale is ON 
 */
if ($(bannerTitle).length && $('body').hasClass('show-promoBanner')) {
  bannerTitle.html(bannerTitleMorningContent);

}

/**
 * Listen to Morning Sale State if title exists and we're under Subcribe & Save
 * 
 * If val = false: Reset Discount Banner title to Default Content (data-content)
 */
if($('body').hasClass('show-promoBanner')) {
  morningSaleStateDef.registerListener(function (val) {
    // console.log('morningSaleState = ' + morningSaleState);
    
    if ($(bannerTitle).length) {
      if (val == 'true') {
        bannerTitle.html(bannerTitleMorningContent);
  
      } else {
        bannerTitle.html(bannerTitleContent);
        
      }
    }
  });
}

//- ScrollTo
if($('[data-scrollto]').length) {
  let scrollToElement = $('[data-scrollto]').attr('data-scrollto')

  $('#topSectionBanner').on('click', function (event) {
      $('html, body').animate({
          scrollTop: $('#' + scrollToElement).offset().top
      }, 1200);
  });
}